import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useProductBySlug } from "@/hooks/useProductData";
import CatalogView from "@/pages/product/components/CatalogView";

const CatalogSkeleton = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <div className="text-center space-y-4">
      <div className="w-16 h-16 rounded-2xl bg-gray-100 animate-pulse mx-auto" />
      <div className="h-4 w-48 bg-gray-100 rounded-lg animate-pulse mx-auto" />
      <div className="h-3 w-32 bg-gray-100 rounded-lg animate-pulse mx-auto" />
    </div>
  </div>
);

const CatalogPage = () => {
  const { companySlug, productSlug } = useParams<{ companySlug: string; productSlug: string }>();
  const { product, loading } = useProductBySlug(companySlug, productSlug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [companySlug, productSlug]);

  if (loading) return <CatalogSkeleton />;

  if (!product) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <i className="ri-error-warning-line text-5xl text-gray-200" />
          </div>
          <p className="text-gray-500 text-lg font-medium mb-2">Không tìm thấy sản phẩm</p>
          <p className="text-gray-400 text-sm">Catalog này không tồn tại hoặc đã bị xoá.</p>
          <p className="text-gray-400 text-sm mt-4">Vui lòng liên hệ admin để được hỗ trợ.</p>
        </div>
      </div>
    );
  }

  return <CatalogView product={product} />;
};

export default CatalogPage;
